export default "__VITE_ASSET__Bpb3jRHq__"